import axios from 'axios'
import Http from './http.init'
import { ResponseWrapper, ErrorWrapper } from './util'
import $store from '../store'
import $router from '../router'
import VueCookie from 'vue-cookie'; 
import { API_URL } from '../.env'

/**
 ******************************
 * @API
 ******************************
 */

export function getCurrentUser() {
  
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.VUE_APP_URL}/users/current`, {  })
      .then(function(response){
        //_setAuthData(response);
        $store.dispatch('user/setLoginState', {login: true});
        return resolve(new ResponseWrapper(response, response.data))
      }
      ).catch(
          function (error) {
            if (error.response.status == '401') {
              $store.dispatch('user/setLoginState', {login: false});
              //auth failed
            } 
            //reject(
            //  new ErrorWrapper(error)
           // )
          }
        
        );
  })
}

export function makeLogin ({ email, password }) {
  VueCookie.set('email', email, 30);
  VueCookie.set('password', password, 30);
  return new Promise((resolve, reject) => {
    axios.post(`${process.env.VUE_APP_URL}/users/sessions`, { email, password })
      .then(function(response){
        _setAuthData(response);
        return resolve(new ResponseWrapper(response, response.data))
      }
      ).catch(error => reject(new ErrorWrapper(error)))
  })
}

export function makeLogout () {
  //todo копипаста
  $store.commit('user/SET_CURRENT_USER', {})
  $store.commit('auth/SET_ATOKEN_EXP_DATE', null);
  // reset tokens in localStorage
  localStorage.setItem('refreshToken', '');
  localStorage.setItem('accessToken', '');
  $router.push({ name: 'login' })
}

export function refreshTokens () {
  return new Promise((resolve, reject) => {
    axios.post(`${process.env.VUE_APP_URL}users/sessions`, { email: VueCookie.get('email'), password: VueCookie.get('password') })
      .then(response => {
        _setAuthData(response)
        return resolve(new ResponseWrapper(response, response.data))
      })
      .catch(error => {
        if (error.response.data.badRefreshToken) {
          console.log('http.init.js >> badRefreshToken: true')
          _resetAuthData()
          $router.push({ name: 'index' })
          return reject(new ErrorWrapper(error))
        }
        if (error.response.data.refreshTokenExpiredError) {
          console.log('http.init.js >> refreshTokenExpiredError')
          _resetAuthData()
          $router.push({ name: 'index' })
          return reject(new ErrorWrapper(error))
        }
      })
  })
}

/**
 ******************************
 * @methods
 ******************************
 */

export function isAccessTokenExpired () {
  const accessTokenExpDate = $store.state.auth.accessTokenExpDate - 1
  const nowTime = Math.floor(new Date().getTime() / 1000)

  return accessTokenExpDate <= nowTime
}

export function getRefreshToken () {
  return localStorage.getItem('refreshToken')
}

export function getAccessToken () {
  return localStorage.getItem('accessToken')
}

function _resetAuthData () {
  // reset userData in store
  $store.commit('user/SET_CURRENT_USER', {})
  $store.commit('auth/SET_ATOKEN_EXP_DATE', null)
  // reset tokens in localStorage
  localStorage.setItem('refreshToken', '')
  localStorage.setItem('accessToken', '')
}

function _setAuthData (response) {
  
  $store.dispatch('user/setLoginState', {login: true});
  localStorage.setItem('userData', JSON.stringify(response.data));
  localStorage.setItem('refreshToken', response.headers.authorization);
  localStorage.setItem('accessToken', response.headers.authorization);
}

function _storeUser (response) {

}